<script>
    import { onMount } from "svelte";

    import { PageLoading } from "../../../Components/Common/index.svelte";

    import PatientEncounterActivityLogsTable from "../components/PatientEncounterActivityLogsTable.svelte";
    import PatientEncounterEclipseLogsTable from "../components/PatientEncounterEclipseLogsTable.svelte";

    import { showError } from "../../../Utils/utilFunctions.svelte";

    import { loadActivityAndEncounterLogs } from "../helpers/encounterHelper.svelte";

    export let patientEncounterId = Number(0),
        logsLoaded = false,
        totalEclipseLogs = 0,
        totalActivityLogs = 0,
        eclipseLogsData = [],
        extendedLogs = false,
        activityLogsData = [];

    let isLoadingLogs = false;

    // This runs every time `extendedLogs` changes
   

    onMount(() => {
        if (patientEncounterId && !logsLoaded) loadLogs(patientEncounterId);
    });

    const loadLogs = async (id) => {
        isLoadingLogs = true;

        const res = await loadActivityAndEncounterLogs(id, extendedLogs);

        if (res.error) showError(res.error);
        else {
            logsLoaded = true;
            eclipseLogsData = [...res.eclipseLogs];
            activityLogsData = [...res.activityLogs];
            totalActivityLogs = res.totalActivityLogs ?? 0;
            totalEclipseLogs = res.totalEclipseLogs ?? 0;
        }

        isLoadingLogs = false;
    };

    const showHideExtendedLogs = async () => {
        extendedLogs = !extendedLogs;
        await loadLogs(patientEncounterId);
    }

    // HELPER FUNCTIONS
</script>

{#if isLoadingLogs}
    <PageLoading />
{:else}
    <div class="relative flex-1">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 mt-4">
            <PatientEncounterEclipseLogsTable 
                bind:totalEclipseLogs={totalEclipseLogs} 
                {eclipseLogsData} 
            />
            <PatientEncounterActivityLogsTable 
                bind:totalActivityLogs={totalActivityLogs} 
                bind:extended={extendedLogs}
                {activityLogsData}
                {showHideExtendedLogs}
            />
        </div>
    </div>
{/if}
